// NOTE: These sources should be in sync with legacy's and astraeus' vonq_integration.rb
//   PAID_POSTING_SOURCE and OPN_SOURCE
export const PAID_POSTING_SOURCE = 'Paid Posts';
export const OPN_SOURCE = 'Free Posts';

// NOTE: This is a specific source for Vonq's Job Board Bundle campaign
export const JOB_BOARD_BUNDLE_SOURCE = 'Job Board Bundle';
